import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Carousel from '../Carousel';
import Container from '../../component/Container';
import styles from './index.scss';
import '../../../../../assets/images/threeDicon.svg';
import Popup from '../Popup';
import LazyImage from '../LazyImage';

class RelatedMedia extends React.Component {
    constructor() {
        super();
        this.state = {
            openPopup: false,
            activeItem: 0,
            scrollPosition: 0,
        };
    }

    componentDidMount() {
        document.addEventListener('webkitfullscreenchange', this.exitFullscreen);
    }

    componentWillUnmount() {
        document.removeEventListener('webkitfullscreenchange', this.exitFullscreen);
    }

    exitFullscreen = () => {
        const { scrollPosition } = this.state;
        if (window.scrollY !== scrollPosition) {
            window.scroll(0, scrollPosition);
        }
    };

    updateSlider = index => {
        this.setState({ activeItem: index });
    };

    popupChange(open) {
        document.body.classList[open ? 'add' : 'remove']('modal-open');
        this.setState({
            openPopup: open,
        });

        if (open) {
            this.setState({ scrollPosition: window.scrollY });
        }
    }

    render() {
        const { map3dPreview } = this.props;
        const items = this.props.data.map((item, i) => {
            const mediaClasses = classNames({
                [styles.media]: true,
                [styles.video]: item.mediaType === 'video',
                [styles.threeD]: item.mediaType === '3dModel',
                'related-media-analytics': true,
            });
            return (
                <div
                    onClick={() => {
                        this.popupChange(true);
                        this.setState({ activeItem: i });
                    }}
                    key={`media-${i}`}
                    className={styles.item}
                >
                    <div className={mediaClasses} data-video-name={item.nameTag}>
                        <LazyImage
                            extendClass={styles.mediaPreview}
                            name={item.name}
                            src={
                                item.mediaType === 'video'
                                    ? item.previewUrl
                                    : map3dPreview[item.sketchfabId] || ''
                            }
                        />
                    </div>
                    <div className={styles.label}>{item.name}</div>
                </div>
            );
        });
        return (
            <Container>
                <Carousel
                    activeItem={this.state.activeItem}
                    additionalParams={{
                        slidesPerView: 4,
                        slidesPerGroup: 3,
                        breakpoints: {
                            960: {
                                slidesPerView: 2,
                                slidesPerGroup: 1, // swiper lib issue
                            },
                        },
                    }}
                    title={this.props.title}
                    extraClassForTitle={styles.mediaTitle}
                >
                    {items}
                </Carousel>
                <Popup
                    opened={this.state.openPopup}
                    toClose={index => {
                        this.popupChange(false);
                        this.setState({ activeItem: index });
                    }}
                    title={this.props.pageTitle}
                    changeItem={this.updateSlider}
                    mediaItems={this.props.data}
                    activeItem={this.state.activeItem}
                />
            </Container>
        );
    }
}
RelatedMedia.propTypes = {
    title: PropTypes.string,
    data: PropTypes.array.isRequired,
    dataArrayOf: PropTypes.arrayOf({
        url: PropTypes.string.isRequired,
        name: PropTypes.string,
        mediaType: PropTypes.string.isRequired,
        previewUrl: PropTypes.string,
        sketchfabId: PropTypes.string,
    }),
    pageTitle: PropTypes.string.isRequired,
    map3dPreview: PropTypes.object,
};
export default RelatedMedia;
